import { createRoot } from 'react-dom/client';
// import {
//   ChakraProvider as ThemeProvider,
//   extendTheme,
//   Center,
// } from '@chakra-ui/react';
import { matchPath } from 'react-router-dom';

import './trusted-security-policies';
import './extensions';
import 'simplebar/src/simplebar.css';
import 'react-modern-drawer/dist/index.css';
import './styles/index.css';
// Import Kula components styles
import '@kula-ai/components/style.css';
import { createBrowserHistory } from 'history';

import { App as Core } from './app';
// import { SignUpApp } from '@/signup/app';
// import { AppLoading } from './app/AppLoading';
// import { customTheme } from './theme';
import './utils/yup';

// integrations
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { AssessmentApp } from './assessment/app';
import { IntegrationApp } from 'integrations/app';
import { CandidateSurveyApp } from './candidateSurvey/app';

if (import.meta.env.VITE_SENTRY_DSN) {
  const history = createBrowserHistory();

  const routes = [
    { path: '/signup' },
    { path: '/login' },
    { path: '/password_reset' },
    { path: '/intro/addemail' },
    { path: '/intro/consent' },
    { path: '/circles/:companyId' },
    { path: '/circles' },
    { path: '/contacts/:contactId' },
    { path: '/contacts' },
    { path: '/interviews/all' },
    { path: '/interviews/:interviewId' },
    { path: '/settings' },
    { path: '/tasks' },
    { path: '/blueprints/:blueprintId' },
    { path: '/flows/:outreachId' },
    { path: '/flows' },
    { path: '/templates/:templateId/edit' },
    { path: '/templates/:templateId/clone' },
    { path: '/templates/new' },
    { path: '/templates' },
    { path: '/reports-home' },
    { path: '/reports/flow-health' },
    { path: '/reports/diversity' },
    { path: '/reports/kpi' },
    { path: '/reports/team-productivity' },
    { path: '/reports/ats' },
    { path: '/reports' },
    { path: '/projects/:projectId' },
    { path: '/projects' },
    { path: '/projects/reviews' },
    { path: '/rippling' },
    { path: '/' },
  ];

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    integrations: [
      new Integrations.BrowserTracing(),
      new Sentry.Replay(),
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(
          history,
          routes,
          matchPath
        ),
        shouldCreateSpanForRequest: (url) =>
          !url.includes('kula-ai-attachments-prod.s3.amazonaws.com/resumes'),
      }),
    ],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // TODO update this once testing is done
    tracesSampleRate: 1.0,
    ignoreErrors: [
      /^ChunkLoadError$/,
      // Avast extension error
      '_avast_submit',
    ],
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

const AppToRender = () => {
  // const { feSignup } = useFlags();
  // const isSignUp = window?.location?.host?.split('.')?.[0] === 'signup';
  const isAssessment = window?.location?.host?.split('.')?.[0] === 'assessment';
  //https://integration.kula.ai/rippling
  const isIntegration =
    window?.location?.host?.split('.')?.[0] === 'integration';

  const isCandidateSurvey =
    window?.location?.host?.split('.')?.[0] === 'survey';
  // const theme = extendTheme({ ...customTheme });

  // if (process.env.REACT_APP_LAUNCHDARKLY && typeof feSignup !== 'boolean') {
  //   return (
  //     <ThemeProvider theme={theme}>
  //       <Center width="100%" height="100%">
  //         <AppLoading />
  //       </Center>
  //     </ThemeProvider>
  //   );
  // }

  // if (isSignUp && feSignup) {
  //   return <SignUpApp />;
  // }

  if (isAssessment) {
    return <AssessmentApp />;
  }
  if (isIntegration) {
    return <IntegrationApp />;
  }
  if (isCandidateSurvey) {
    // TODO: Uncomment this once the candidate survey app is ready
    return <CandidateSurveyApp />;
  }
  return <Core />;
};

export const AppWithLD = withLDProvider({
  clientSideID: import.meta.env.VITE_LAUNCHDARKLY,
  context: {
    kind: 'user',
    key: `${window.location.host.split('.')[0]}:anonymous`,
  },
  options: {
    streaming: false,
  },
})(AppToRender);

// posthog config
if (import.meta.env.VITE_PUBLIC_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    loaded: function (ph) {
      // setting posthog on window for accessing posthog toolbar
      Object.assign(window, { posthog: ph });
    },
  });
}

export const App = () => {
  if (import.meta.env.VITE_LAUNCHDARKLY) {
    return <AppWithLD />;
  }
  return (
    <PostHogProvider client={posthog}>
      <AppToRender />
    </PostHogProvider>
  );
};

root.render(<App />);
